paf-radio-checkbox {
  @include host-component-properties-without-host;

  display: block;
  align-self: stretch;

  --paf-radio-checkbox-font-size: 16;
  --paf-radio-checkbox-line-height: 24;
  --paf-radio-checkbox-input-size: 22;
  --paf-radio-checkbox-input-padding: 2;
  --paf-radio-checkbox-gap: 8;
  --paf-radio-checkbox-label-color: var(--paf-global-post-brand-secondary);
  --paf-radio-checkbox-label-color-active: var(--paf-global-post-brand-black);
  --paf-radio-checkbox-label-padding-block: 10;
  --paf-radio-checkbox-border-width: var(--paf-global-border-width-2x);
  --paf-radio-checkbox-transition-duration: 180ms;
  --paf-radio-checkbox-min-click-target-dimension: 44;
  --paf-radio-checkbox-margin-block-start: 11;

  @include forced-colors {
    --paf-radio-checkbox-label-color: CanvasText;
    --paf-radio-checkbox-label-color-active: LinkText;
    --paf-radio-checkbox-transition-duration: 0;
  }
}

.paf-radio-checkbox {
  $inputAndGapSize: calc(px-to-rem(var(--paf-radio-checkbox-input-size)) + px-to-rem(var(--paf-radio-checkbox-gap)));

  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  column-gap: px-to-rem(var(--paf-radio-checkbox-gap));
  color: var(--paf-radio-checkbox-label-color);
  font-size: px-to-rem(var(--paf-radio-checkbox-font-size));
  line-height: px-to-rem(var(--paf-radio-checkbox-line-height));

  .paf-radio-checkbox__input {
    position: absolute;
    inset-block-start: px-to-rem(11);
    inset-inline-start: 0;
    width: px-to-rem(var(--paf-radio-checkbox-input-size));
    height: px-to-rem(var(--paf-radio-checkbox-input-size));
    opacity: 0;
    margin: 0;
    cursor: pointer;

    &:focus-visible ~ .paf-radio-checkbox__label {
      @include focus-visible;
    }
  }

  .paf-radio-checkbox__label {
    flex: 1;
    user-select: none;
    cursor: pointer;
    padding-inline-start: calc($inputAndGapSize);
    padding-inline-end: px-to-rem(var(--paf-radio-checkbox-gap));
    padding-block: px-to-rem(var(--paf-radio-checkbox-label-padding-block));
    line-height: px-to-rem(var(--paf-radio-checkbox-line-height));
    transition-duration: var(--paf-radio-checkbox-transition-duration);
    transition-property: color, opacity;
    -webkit-tap-highlight-color: transparent;

    @include reduced-motion {
      transition: none;
    }

    &:hover {
      @include mouse-only {
        color: var(--paf-radio-checkbox-label-color-active);
      }
    }
  }

  .paf-radio-checkbox__checkmark,
  .paf-radio-checkbox__circle {
    display: block;
    position: relative;
    pointer-events: none;
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: px-to-rem(var(--paf-radio-checkbox-input-size));
    height: px-to-rem(var(--paf-radio-checkbox-input-size));
    padding: px-to-rem(var(--paf-radio-checkbox-input-padding));
    border: px-to-rem(var(--paf-radio-checkbox-border-width)) solid currentcolor;
    margin-block-start: px-to-rem(var(--paf-radio-checkbox-margin-block-start));
    margin-inline-end: calc(-1 * $inputAndGapSize);
    fill: currentcolor;
    transition: opacity var(--paf-radio-checkbox-transition-duration);

    @include reduced-motion {
      transition: none;
    }

    * {
      opacity: 0;
      transition: opacity var(--paf-radio-checkbox-transition-duration);

      @include reduced-motion {
        transition: none;
      }
    }
  }

  .paf-radio-checkbox__circle {
    border-radius: 100%;
  }

  .paf-radio-checkbox__input:disabled {
    & ~ .paf-radio-checkbox__label,
    & ~ .paf-radio-checkbox__checkmark,
    & ~ .paf-radio-checkbox__circle {
      pointer-events: none;
      cursor: default;
      opacity: 0.6;
    }
  }

  .paf-radio-checkbox__input:focus {
    & ~ .paf-radio-checkbox__label,
    & ~ .paf-radio-checkbox__checkmark,
    & ~ .paf-radio-checkbox__circle {
      color: var(--paf-radio-checkbox-label-color-active);

      @include forced-colors {
        color: var(--paf-radio-checkbox-label-color);
      }
    }
  }

  &:has(.paf-radio-checkbox__label:hover) {
    & .paf-radio-checkbox__checkmark,
    & .paf-radio-checkbox__circle {
      color: var(--paf-radio-checkbox-label-color-active);
    }
  }

  &:has(.paf-radio-checkbox__input:checked:not(:active)) {
    & .paf-radio-checkbox__checkmark,
    & .paf-radio-checkbox__circle,
    & .paf-radio-checkbox__label {
      color: var(--paf-radio-checkbox-label-color-active);
    }
  }

  .paf-radio-checkbox__input:checked {
    & ~ .paf-radio-checkbox__checkmark *,
    & ~ .paf-radio-checkbox__circle * {
      opacity: 1;
    }
  }
}
